/**
 * SessionHeader Component
 *
 * Displays session title, task counter, progress bar, and cancel button.
 */

import type { Task } from '@core/types/services';
import { SessionProgressBar, type TaskResult } from './SessionProgressBar';
import styles from '../../practice-session.module.css';

export interface SessionHeaderProps {
  /** Current task index (0-based) */
  currentTaskIndex: number;
  /** Total number of tasks */
  totalTasks: number;
  /** Current task (for displaying ID) */
  currentTask: Task | null;
  /** Progress percentage (0-100) - kept for backward compatibility */
  progress: number;
  /** Callback when cancel button is clicked */
  onCancel: () => void;
  /** Optional task results for marker coloring */
  taskResults?: TaskResult[];
  /** Whether to show individual task markers */
  showTaskMarkers?: boolean;
}

/**
 * Header component for practice session
 */
export function SessionHeader({
  currentTaskIndex,
  totalTasks,
  currentTask,
  onCancel,
  taskResults,
  showTaskMarkers = false,
}: SessionHeaderProps) {
  return (
    <div className={styles['practice-session__header']}>
      <div className={styles['practice-session__header-top']}>
        <div className={styles['practice-session__header-left']}>
          <h2 className={styles['practice-session__title']}>Übungssitzung</h2>
          <span className={styles['practice-session__task-counter']}>
            {currentTaskIndex + 1}/{totalTasks}
          </span>
          {currentTask && (
            <span className={styles['practice-session__task-id']}>
              ID: {currentTask.id}
            </span>
          )}
        </div>
        <button
          onClick={onCancel}
          className={styles['practice-session__cancel-btn']}
        >
          Abbrechen
        </button>
      </div>

      {/* Animated Progress bar */}
      <SessionProgressBar
        currentIndex={currentTaskIndex}
        totalTasks={totalTasks}
        showTaskMarkers={showTaskMarkers}
        {...(taskResults && { taskResults })}
      />
    </div>
  );
}
